import { FC } from "react";
import { shiftDateKey, todayDateKey } from "../map-asset/multiDay/dateUtils";

type Props = {
  dateKey: string;
  onChange: (nextDateKey: string) => void;
  className?: string;
};

// one day at a time, prev/next or pick directly - shared between the
// vehicle selector (pick the day before you even pick vehicles) and the
// panel header (change it after you're already looking at a selection)
export const DayStepper: FC<Props> = ({ dateKey, onChange, className }) => (
  <div className={`flex items-center gap-1.5 ${className ?? ""}`}>
    <button
      type="button"
      onClick={() => onChange(shiftDateKey(dateKey, -1))}
      aria-label="Previous day"
      className="size-7 shrink-0 flex items-center justify-center rounded-md border border-gray-200 text-heading-gray888 hover:bg-gray-100"
    >
      &lsaquo;
    </button>
    <input
      type="date"
      value={dateKey}
      max={todayDateKey()}
      onChange={(e) => onChange(e.target.value)}
      className="flex-grow min-w-0 border border-gray-200 rounded-md px-2 py-1 text-xs text-accent-blue-dark"
    />
    <button
      type="button"
      onClick={() => onChange(shiftDateKey(dateKey, 1))}
      disabled={dateKey >= todayDateKey()}
      aria-label="Next day"
      className="size-7 shrink-0 flex items-center justify-center rounded-md border border-gray-200 text-heading-gray888 hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-transparent"
    >
      &rsaquo;
    </button>
  </div>
);
